/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

// import { isNil } from 'lodash';
import isNil from 'lodash/isNil';
import { JSXElementConstructor, useEffect, useState } from 'react';
import SuccessErrorModal, { MessageType } from '../../components/modals/SuccessErrorModal';
import idmRequest from '../../lib/idmRequest';
import styles from '../../styles/FormLayout.module.css';
import myengmodelStyles from '../../styles/myEngineModelStyle.module.css';
import Loading from '../02-molecules/Loading';
import EngineModelStatus from './EngineModelStatus';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import { FRAuth, FRLoginFailure, FRLoginSuccess, FRStep, StepType } from '@forgerock/javascript-sdk';
import { trees } from '../../config';
import FROutputCallbackBasedView from '../forms/common/FROutputCallBackBasedView';
import { StageProgressBadge } from '../layout/StageProgressBadge';
import SuspendMessage from '../forms/common/SuspendMessage.tsx';
import ErrorMessage from '../../components/01-atoms/ErrorMessage';

const MyEngineModelStatus = () => {



  const [roleRequestData, setroleRequestData] = useState<any>();
  const [completedResNameGroupedData, setCompletedResNameGroupedData] = useState<any>();
  const [pendingResNameGroupedData, setPendingResNameGroupData] = useState<any>();
  const [message, setMessage] = useState('');
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [showContent, setShowContent ] = useState({completed : true,pending :true});
  const [contentToDisplay, setContentToDisplay ] = useState<string>("");
  const [messageType, setMessageType] = useState(MessageType.info);

  //step related states.
  const [step, setStep] = useState<FRStep | FRLoginFailure | FRLoginSuccess | null>(null);

  const header: string = "new engine request"
  const subHeaderDescription: string = "Below is a summary of engine models with active access. Engine models with pending status may take up to three days for approval. For further assistance, select contact to view client admin's email."
  const tree = trees.profileUpdate;

  const handleOpen = () => {
    setIsAlertOpen(true);
  };
  const handleClose = () => {
    setIsAlertOpen(false);
  };

  useEffect(() => {
    (async () => {
      try {
        await getRoleStatusList();
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  useEffect(()=> {
    if (roleRequestData?.activeEngines.length === 0){
      setShowContent({completed : false,pending :true})
    }
    if(roleRequestData?.pendingRequests.length===0){
      setShowContent({completed : true,pending :false})
    }
    if(roleRequestData?.activeEngines.length === 0 && roleRequestData?.pendingRequests.length === 0){
      setShowContent({completed : false,pending :false})
    }
  },[roleRequestData]);


  
  const getRoleStatusList = async () => {
    const data = await idmRequest('/endpoint/getEngineModelRequests', 'get');
    if (!isNil(data)) {
      console.log("Data ===================== ",data)
      const completedGroupedroles= new Map<string,any>();
      const pendingGroupedroles= new Map<string,any>();
      data.activeEngines.forEach((info:any)=>{ 
        const key = info.name
        // if(!info.processVariables.taskDeleted && !info.processVariables.rejected){
        const values = completedGroupedroles.get(key);
        if(!values){
          completedGroupedroles.set(key,[info])
        } else {
          values.push(info)
        }
      // }
      })

      data.pendingRequests.forEach((info:any)=>{ 
        const engineModelsArray = info.processVariables.engineModels.split(',')
        for (let eng in engineModelsArray){
          const key = engineModelsArray[eng]; 
          const values = pendingGroupedroles.get(key);
          if(!values){
            var infoClone = cloneDeep(info)
            infoClone.processVariables.engineModels = key
            pendingGroupedroles.set(key,[infoClone])
          } else {
            infoClone.processVariables.engineModels = key
            values.push(infoClone)
          }
        }
      })
      
      setIsAlertOpen(false)
      setroleRequestData(data);
      setCompletedResNameGroupedData(completedGroupedroles)
      setPendingResNameGroupData(pendingGroupedroles)
    }
    else {
      setIsAlertOpen(true);
      setMessage('Failed to load organization and engine Models');
    }
  }




  const getCompletedEngineModelRequestsGrouped = () => {
    let uiElement: JSX.Element = <></>;
    let children: JSX.Element[] = [];
  
    if(!isNil(completedResNameGroupedData)){

      for (const [key, value] of completedResNameGroupedData) { 
        children.push(
          <div className={myengmodelStyles.rolesStatus}>
            {getCompletedEngineModelRequests(value)}
          </div>
        )
      }   
            uiElement = <div>{children}</div>;
            return uiElement;
    }
    else{
      return <></>;
    }
  }

  const getCompanyRegistrationView = () => {
    let uiElement: JSX.Element = <Loading size={100} />;
    if (step && step.type === StepType.Step) {
      switch (step.getStage()) {
        case 'EngineModelCountry':
        case 'EngineRequest':
          uiElement = (<>
            <FROutputCallbackBasedView step={step as FRStep} setStep={setStep}
              tree={tree} messageType={messageType} setMessageType={setMessageType}
              message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen}/>
          </>);
          break;
        case 'SuspendMessage':
          uiElement = <SuspendMessage step={step as FRStep} />;
          break;
      }
    } else if (step && step.type === StepType.LoginFailure) {
      // setUpIntialStep(step.payload.message || '');
      uiElement=<ErrorMessage message={step?.getMessage()} code={step?.getCode()}/>
    }
    return uiElement;

  }

  const setUpIntialStep = async (message: string) => {
    const initialStep = await FRAuth.start({ tree });
    setStep(initialStep);
    setIsAlertOpen(true)
    setMessageType(MessageType.error);
    setMessage(message)

  }


  const getCompletedEngineModelRequests = ( value: any) => {
    let uiElement: JSX.Element = <></>;
    let children: JSX.Element[] = [];
    if (!isNil(value) ) {
      value.forEach((info: any) => {
        children.push(
          <EngineModelStatus engineData = {info} engineColor = {'#5B6376'} modelStatus = {'Active'} icon={'check'}></EngineModelStatus>
        );
      });
      uiElement = <div>{children}</div>;
      return uiElement;
    }
    return <></>;
  };

  const getPendingEngineModelGrouped = () => {
    let uiElement: JSX.Element = <></>;
    let children: JSX.Element[] = [];
  
    if(!isNil(pendingResNameGroupedData)){

      for (const [key, value] of pendingResNameGroupedData) { 
        children.push(
          <div className={myengmodelStyles.rolesStatus}>
            {getPendingEngineModelRequests(value)}
          </div>
        )
      }   
            uiElement = <div>{children}</div>;
            return uiElement;
    }
    else{
      return <></>;
    }
  }


  const getPendingEngineModelRequests = ( value: any) => {
    let uiElement: JSX.Element = <></>;
    let children: JSX.Element[] = [];
    if (!isNil(value) ) {
      value.forEach((info: any) => {
        children.push(
          <EngineModelStatus engineData = {info} engineColor = {'#00A9E0'} modelStatus = {'Pending'} icon={'sync'}></EngineModelStatus>
        );
      });
      uiElement = <div>{children}</div>;
      return uiElement;
    }
    return <></>;
  };

  const handleJourneystates = () => {
    setContentToDisplay("journey");
    (async function getStep() {
      const journeyCode = 'updateEnginemodelsflow' 
      //new URLSearchParams(window.location.search).get('resumeCode') || '';
      try {
        const initialStep = await FRAuth.start({ tree, query: { journeyCode } });
        setStep(initialStep);
      } catch (err) {
        console.error(`Error: request for initial step; ${err}`);
      }
    })();
  }


  let uiElement: JSX.Element = <></>;
  let children: JSX.Element[] = [];
  { isEmpty(contentToDisplay) 
    ? 
      children.push(
    <>
      <div className={myengmodelStyles.container}>
        <main className={styles.mainEngineModels}>
          <div className={styles.headerGroup}>
            {header && (
              <div
                className={`brand-voice ${styles.header}`}
                dangerouslySetInnerHTML={{ __html: header }}
              ></div>
            )}
            {subHeaderDescription && subHeaderDescription && (
              <div
                className={styles.subHeaderDescription}
                dangerouslySetInnerHTML={{ __html: subHeaderDescription }}
              ></div>
            )}
            <>
              <button className={styles.RequestEngModelButton} type="submit" 
              onClick = {handleJourneystates}>
                <div className={styles.RequestEngModelButtonText}>
                  <div>{"Request New Engine"}</div>
                </div>
              </button></>
            {/* <button>Request New Engine</button> */}

            <div className={myengmodelStyles.border}>
              <div className={styles.headerboxEnginemodels}>
                <div className={styles.headerboxlableEngineModel2}>Engine</div>
                <div className={styles.headerboxlableEngineModels3}>Status</div>
                <div className={styles.headerboxlableEngineModels3}>Support</div>
              </div>
              {
                roleRequestData ? 
                (<>
                  {showContent.pending && (
                    <div className={myengmodelStyles.content}>
                     <div className={myengmodelStyles.sideHeaderContainer}>
                      <div className={myengmodelStyles.sideheader} dangerouslySetInnerHTML={{ __html: "Pending " }} ></div>
                     </div>
                      {getPendingEngineModelGrouped()}
                    </div>
                  )}
                  {showContent.completed && (
                    <div className={myengmodelStyles.content}>
                      <div className={myengmodelStyles.sideHeaderContainer}>
                      <div className={myengmodelStyles.sideheader} dangerouslySetInnerHTML={{__html: "Active" }} ></div>
                      </div>
                      {getCompletedEngineModelRequestsGrouped()}
                    </div>
                  )}
                </>)
                : (<div style={{ marginTop: '10px', marginBottom: '40px' , border :'1px solid white'}} className="lowHeight">
                <Loading size={100}/>
              </div>)
              }
            </div>
          </div>
        </main>
      </div>
      </> )
    :
      children.push(
                <>
                  {getCompanyRegistrationView()}
                </>
              )
  }

  uiElement= <>{children}</>
  return uiElement
};

export default MyEngineModelStatus;